<template lang="html">
  <textarea
    v-model="value"
    rows="5"
    :class="['form-control mb-3','is-' + state]"
    required
  ></textarea>
</template>

<script>
export default {
  name: 'input-string',
  props: {
    model: {
      type: String,
    },
    state: {
      type: String,
      default: null,
    },
  },
  computed: {
    value: {
      get() {
        return this.model;
      },
      set(value) {
        return this.$emit('update:model', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
